// extracted by mini-css-extract-plugin
export var numpadContainer = "_lv-1";
export var phoneButton = "_lv-0";